/**
 * @Description 创建机会点-周边门店-表格列表
 */
import { FC, useEffect, useState } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import { chancePointPoiPage } from '@/common/api/expandStore/chancepoint';
import { isNotEmptyAny } from '@lhb/func';

const StoreTableList: FC<any> = ({
  tableFilter,
  curDetail,
  setCurDetail
}) => {
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false); // 是否当前页刷新

  useEffect(() => {
    if (isNotEmptyAny(tableFilter)) {
      setRefreshCurrent(false);
    }
  }, [tableFilter]);

  const columns = [
    {
      key: 'name',
      title: '名称',
      dragChecked: true,
      importWidth: true,
    },
    {
      key: 'address',
      title: '地址',
      dragChecked: true,
      importWidth: true,
    },
    {
      key: 'distance',
      title: '距离',
      dragChecked: true,
      width: 72,
      forceTooltipRender(_: string) {
        return _ ? (_ + 'm') : '-';
      },
      render(_: string) {
        return _ ? (_ + 'm') : '-';
      }
    },
  ];

  const methods = useMethods({
    async onFetch(params) {
      const data = await chancePointPoiPage(params);
      return {
        dataSource: data.objectList,
        count: data.totalNum
      };
    },
  });

  return (
    <V2Table
      className={styles.storeTableList}
      key={'id'}
      pageSize={10}
      paginationConfig={{
        simple: true,
      }}
      rowKey='name'
      filters={tableFilter}
      scroll={{ x: 'max-content' }}
      defaultColumns={columns}
      onFetch={methods.onFetch}
      refreshCurrent={refreshCurrent}
      voluntarilyEmpty
      hideColumnPlaceholder
      rowClassName={(record) => {
        return (record.name === curDetail?.name && record.address === curDetail?.address) ? 'checked pointer' : 'pointer';
      }}
      onRow={(record) => {
        return {
          onClick: () => {
            setCurDetail(record);
            // bigdataFn('23629346-0e01-4a33-885e-8149a2cfeb86', '详情-经营门店列表-点击列表', '点击了详情-经营门店列表-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
          }, // 点击行
        };
      }}
    />
  );
};

export default StoreTableList;
